//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    export default{
        name:'bb_form_e_detail',
        data(){
            return{
                get_host:host.host,
                form:{
                    room_number:'',
                    is_card:'',
                    entry_time:'',
                    mom_name:'',
                    baby_name:'',
                    sex:'',
                    birth_date:'',
                    birth_week:'',
                    blood_type:'',
                    birth_weight:'',
                    birth_length:'',
                    apgar_score:'',
                    leave_hos_summary:'',
                    use_drug_history:'',
                    allergy_history:'',
                    new_baby_special_case:'',
                    leave_hos_jaundice_num:'',
                    feed_case:'',
                    milk_pow_brand:'',
                    micturition_case_status:'',
                    micturition_num:'',
                    habit_diaper_brand:'',
                    defecation_case_status:'',
                    defecation_num:'',
                    temperature:'',
                    heart_rate_num:'',
                    breathing_num:'',
                    entry_weight:'',
                    spotwo:'',
                    face_colour:'',
                    cry_sound:'',
                    reaction:'',
                    limb:'',
                    limb_tension_activity:'',
                    limb_tension_activity_be_position:'',
                    limb_tension_activity_lose_position:'',
                    birth_injury:'',
                    nerve_reflex_status:'',
                    nerve_reflex_abnormal_desc:'',
                    nutrition_development_status:'',
                    whole_body_skin_status:'',
                    whole_body_skin_be_position:'',
                    whole_body_skin_rash_position:'',
                    whole_body_skin_remark:'',
                    front_fontanelle_status:'',
                    mouth_mucosa_status:'',
                    eye_blood_secretion:'',
                    sclera_yellow_dye:'',
                    nose_shape_status:'',
                    nose_shape_place_name:'',
                    breathing_open_status:'',
                    ear_shape_status:'',
                    ear_shape_place_name:'',
                    abroad_ear_way_shape_status:'',
                    abroad_ear_way_shape_desc:'',
                    umbilicus_abnorma_status:'',
                    navelscab_case_staus:'',
                    suck_case_status:'',
                    hips_status:'',
                    vulva_status:'',
                    vulva_abnormal_case_desc:'',
                    anus_status:'',
                    urethra_crack_status:'',
                    falsex_menstruation_status:'',
                    prevention_inoculation_status:'',
                    prevention_inoculation_has_name:'',
                    jaundice_index_num:'',
                    other_special_case:'',
                    baby_nursing_abstract:'',
                    autograph:'',
                    assessment_time:''
                },
                
                showSignature:true,
                option:{
                    penColor:"rgb(0, 0, 0)"
                },
            }
        },
        methods:{
            save(){
                let signature ='signature1'
                console.info(this.$refs[signature])
                let png = this.$refs[signature].save()
                this.form.autograph = encodeURI(png)
                this.showSignature = true
            },
            edit(){
                this.showSignature = false
            },
            clear(){
                let signature ='signature1'
                let refs = this.$refs[signature].clear()
                this.form.autograph = ''
            },
            submitForm(){
                this.$router.replace({
                    path:'/bb_form_e_edit',
                    query:{
                        id:this.$route.query.id,
                        form_id:this.$route.query.form_id,
                        baby_id:this.$route.query.baby_id,
                        tabVal: this.$route.query.tabVal
                    }
                })
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        id: this.$route.query.id,
                        tabVal: this.$route.query.tabVal
                    }
                })
            },
             //请求用户基本信息
            apiMemberInfo(){
                let params = {
                    token: this.$cookie.get('token'),
                    maternal_info_id: this.$route.query.id
                }
                Api.checkRoomApi.memberInfo(params).then ( res => {
                    console.info('用户基本信息',res)
                    if(res.errcode == 1){
                        this.form.mom_name = res.data.name
                    }else{
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
        },
        created(){
            this.apiMemberInfo()
            let params ={
                token:this.$cookie.get('token'),
                id:this.$route.query.form_id
            }
            this.$vux.loading.show({
                text: '正在加载'
            })
            console.info(params)
            Api.otherFormApi.getNewBornCheckAssessFind(params).then (res => {
                this.$vux.loading.hide()
                console.info("详情",res.data)
                if(res.errcode==200){
                    this.form.room_number=res.data.room_number
                    this.form.is_card=res.data.is_card
                    this.form.entry_time=res.data.entry_time
                    // this.form.mom_name=res.data.mom_name
                    this.form.baby_name=res.data.baby_name
                    this.form.sex=res.data.sex
                    this.form.birth_date=res.data.birth_date
                    this.form.birth_week=res.data.birth_week
                    this.form.blood_type=res.data.blood_type
                    this.form.birth_weight=res.data.birth_weight
                    this.form.birth_length=res.data.birth_length
                    this.form.apgar_score=res.data.apgar_score
                    this.form.leave_hos_summary=res.data.leave_hos_summary=='1'?'有':'无'
                    this.form.use_drug_history=res.data.use_drug_history
                    this.form.allergy_history=res.data.allergy_history
                    this.form.new_baby_special_case=res.data.new_baby_special_case
                    this.form.leave_hos_jaundice_num=res.data.leave_hos_jaundice_num
                    this.form.feed_case=res.data.feed_case=='1'?'纯母乳喂养':(res.data.feed_case=='2'?'人工喂养':'混合喂养')
                    this.form.milk_pow_brand=res.data.milk_pow_brand
                    this.form.micturition_case_status=res.data.micturition_case_status=='1'?'正常':'尿少'
                    this.form.micturition_num=res.data.micturition_num
                    this.form.habit_diaper_brand=res.data.habit_diaper_brand
                    this.form.defecation_case_status=res.data.defecation_case_status=='1'?'正常':(res.data.defecation_case_status=='2'?'便秘':(res.data.defecation_case_status=='3'?'腹泻':'未排'))
                    this.form.defecation_num=res.data.defecation_num
                    this.form.temperature=res.data.temperature
                    this.form.heart_rate_num=res.data.heart_rate_num
                    this.form.breathing_num=res.data.breathing_num
                    this.form.entry_weight=res.data.entry_weight
                    this.form.spotwo=res.data.spotwo
                    this.form.face_colour=res.data.face_colour=='1'?'红润':'黄染'
                    this.form.cry_sound=res.data.cry_sound=='1'?'响':'弱'
                    this.form.reaction=res.data.reaction=='1'?'好':'差'
                    this.form.limb=res.data.limb=='1'?'红':(res.data.limb=='2'?'白':'紫')
                    this.form.limb_tension_activity=res.data.limb_tension_activity=='1'?'良好':(res.data.limb_tension_activity=='2'?'受限':'')
                    this.form.limb_tension_activity_be_position=res.data.limb_tension_activity_be_position
                    this.form.limb_tension_activity_lose_position=res.data.limb_tension_activity_lose_position
                    this.form.birth_injury=res.data.birth_injury=='1'?'有':'无'
                    this.form.nerve_reflex_status=res.data.nerve_reflex_status=='1'?'正常':'异常'
                    this.form.nerve_reflex_abnormal_desc=res.data.nerve_reflex_abnormal_desc
                    this.form.nutrition_development_status=res.data.nutrition_development_status=='1'?'正常':(res.data.nutrition_development_status=='2'?'过剩':'滞后')
                    // this.form.whole_body_skin_status=res.data.whole_body_skin_status=='1'?'红润':(res.data.whole_body_skin_status=='2'?'黄染':(res.data.whole_body_skin_status=='3'?'完整':(res.data.whole_body_skin_status=='4'?'破损':(res.data.whole_body_skin_status=='5'?'红臀':(res.data.whole_body_skin_status=='6'?'干燥':(res.data.whole_body_skin_status=='7'?'皮疹':(res.data.whole_body_skin_status=='8'?'脓包':(res.data.whole_body_skin_status=='9'?'硬肿':'水肿'))))))))
                    //全身皮肤
                    let Arr1=res.data.whole_body_skin_status
                    for(let i=0;i<Arr1.length;i++){
                        if(Arr1[i]=='1'){
                            Arr1[i]='红润'
                        }else if(Arr1[i]=='2'){
                            Arr1[i]='黄染'
                        }else if(Arr1[i]=='3'){
                             Arr1[i]='完整'
                        }else if(Arr1[i]=='4'){
                             Arr1[i]='破损'
                        }else if(Arr1[i]=='5'){
                             Arr1[i]='红臀'
                        }else if(Arr1[i]=='6'){
                            Arr1[i]='干燥'
                        }else if(Arr1[i]=='7'){
                            Arr1[i]='皮疹'
                        }else if(Arr1[i]=='8'){
                            Arr1[i]='脓包'
                        }else if(Arr1[i]=='9'){
                            Arr1[i]='硬肿'
                        }else if(Arr1[i]=='10'){
                            Arr1[i]='水肿'
                        }
                        this.form.whole_body_skin_status=Arr1.join()
                    }
                    this.form.whole_body_skin_be_position=res.data.whole_body_skin_be_position
                    this.form.whole_body_skin_rash_position=res.data.whole_body_skin_rash_position
                    this.form.whole_body_skin_remark=res.data.whole_body_skin_remark
                    this.form.front_fontanelle_status=res.data.front_fontanelle_status=='1'?'平坦':(res.data.front_fontanelle_status=='2'?'肿胀':'凹陷')
                    this.form.mouth_mucosa_status=res.data.mouth_mucosa_status=='1'?'清洁':(res.data.mouth_mucosa_status=='2'?'破溃':(res.data.mouth_mucosa_status=='3'?'白斑':(res.data.mouth_mucosa_status=='4'?'腭裂':'唇裂')))
                    this.form.eye_blood_secretion=res.data.eye_blood_secretion=='1'?'有':'无'
                    this.form.sclera_yellow_dye=res.data.sclera_yellow_dye=='1'?'有':'无'
                    this.form.nose_shape_status=res.data.nose_shape_status=='1'?'有':'无'
                    this.form.nose_shape_place_name=res.data.nose_shape_place_name
                    this.form.breathing_open_status=res.data.breathing_open_status=='1'?'是':'否'
                    this.form.ear_shape_status=res.data.ear_shape_status=='1'?'有':'无'
                    this.form.ear_shape_place_name=res.data.ear_shape_place_name
                    this.form.abroad_ear_way_shape_status=res.data.abroad_ear_way_shape_status=='1'?'有':'无'
                    this.form.abroad_ear_way_shape_desc=res.data.abroad_ear_way_shape_desc
                    this.form.umbilicus_abnorma_status=res.data.umbilicus_abnorma_status=='1'?'有':'无'
                    this.form.navelscab_case_staus=res.data.navelscab_case_staus=='1'?'未':'已'
                    this.form.suck_case_status=res.data.suck_case_status=='1'?'好':(res.data.suck_case_status=='2'?'较差':'差')
                    this.form.hips_status=res.data.hips_status=='1'?'正常':(res.data.hips_status=='2'?'稍红':'红臀')
                    this.form.vulva_status=res.data.vulva_status=='1'?'正常':'异常'
                    this.form.vulva_abnormal_case_desc=res.data.vulva_abnormal_case_desc
                    this.form.anus_status=res.data.anus_status=='1'?'有':'无'
                    this.form.urethra_crack_status=res.data.urethra_crack_status=='1'?'有':'无'
                    this.form.falsex_menstruation_status=res.data.falsex_menstruation_status=='1'?'有':'无'
                    this.form.prevention_inoculation_status=res.data.prevention_inoculation_status=='1'?'有':'无'
                    this.form.prevention_inoculation_has_name=res.data.prevention_inoculation_has_name
                    this.form.jaundice_index_num=res.data.jaundice_index_num
                    this.form.other_special_case=res.data.other_special_case
                    this.form.baby_nursing_abstract=res.data.baby_nursing_abstract
                    this.form.autograph=res.data.autograph.indexOf(this.get_host) != -1 ? res.data.autograph : this.get_host+res.data.autograph
                    this.form.customer_sign=res.data.customer_sign.indexOf(this.get_host) != -1 ? res.data.customer_sign : this.get_host+res.data.customer_sign
                    this.form.assessment_time=res.data.assessment_time
                    //婴儿护理要点
                    let Arr2=res.data.baby_nursing_check
                    for(let i=0;i<Arr2.length;i++){
                        if(Arr2[i]=='1'){
                            Arr2[i]='单独睡小床，不需要用枕头'
                        }else if(Arr2[i]=='2'){
                            Arr2[i]='避免阳光直射眼睛，及早晒太阳'
                        }else if(Arr2[i]=='3'){
                             Arr2[i]='选择纯棉衣物，衣服单独清洗'
                        }else if(Arr2[i]=='4'){
                             Arr2[i]='奶瓶清洁消毒后再用，加强生活护理'
                        }else if(Arr2[i]=='5'){
                             Arr2[i]='吃奶后拍嗝，加强母乳喂养指导'
                        }else if(Arr2[i]=='6'){
                            Arr2[i]='注意脐带护理、五官护理、皮肤护理'
                        }
                        this.form.baby_nursing_check=Arr2.join()
                    }
                    //接种类型
                    let Arr3=res.data.prevention_inoculation_bar
                    for(let i=0;i<Arr3.length;i++){
                        if(Arr3[i]=='1'){
                            Arr3[i]='乙肝疫苗'
                        }else if(Arr3[i]=='2'){
                            Arr3[i]='卡介苗'
                        }
                        this.form.prevention_inoculation_bar=Arr3.join()
                    }
                }
            })
        }
    }



// WEBPACK FOOTER //
// ./src/components/bb_form_e_detail.vue